/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Status_LoadingInputs */

const id_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const ms_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat...`)
};

const da_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indlæser...`)
};

const de_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lädt...`)
};

const en_us2_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const es_es2_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const es_mx2_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const fil_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naglo-load...`)
};

const fr_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const it_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const hu_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betöltés...`)
};

const nl_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

const no_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laster...`)
};

const pl_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie...`)
};

const pt_br2_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

const pt_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar...`)
};

const ro_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se încarcă...`)
};

const fi_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladataan...`)
};

const sv_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar...`)
};

const vi_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải...`)
};

const tr_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleniyor...`)
};

const cs_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání...`)
};

const bg_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зареждане...`)
};

const ru_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const uk_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження...`)
};

const ar_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التحميل...`)
};

const hi_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड हो रहा है...`)
};

const th_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลด...`)
};

const ja_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中...`)
};

const zh_cn2_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

const zh_hant1_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入中...`)
};

const ko_sales_status_loading = /** @type {(inputs: Sales_Status_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 중...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Sales_Status_LoadingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_status_loading = /** @type {((inputs?: Sales_Status_LoadingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Status_LoadingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_status_loading(inputs)
	if (locale === "ms") return ms_sales_status_loading(inputs)
	if (locale === "da") return da_sales_status_loading(inputs)
	if (locale === "de") return de_sales_status_loading(inputs)
	if (locale === "en-US") return en_us2_sales_status_loading(inputs)
	if (locale === "es-ES") return es_es2_sales_status_loading(inputs)
	if (locale === "es-MX") return es_mx2_sales_status_loading(inputs)
	if (locale === "fil") return fil_sales_status_loading(inputs)
	if (locale === "fr") return fr_sales_status_loading(inputs)
	if (locale === "it") return it_sales_status_loading(inputs)
	if (locale === "hu") return hu_sales_status_loading(inputs)
	if (locale === "nl") return nl_sales_status_loading(inputs)
	if (locale === "no") return no_sales_status_loading(inputs)
	if (locale === "pl") return pl_sales_status_loading(inputs)
	if (locale === "pt-BR") return pt_br2_sales_status_loading(inputs)
	if (locale === "pt") return pt_sales_status_loading(inputs)
	if (locale === "ro") return ro_sales_status_loading(inputs)
	if (locale === "fi") return fi_sales_status_loading(inputs)
	if (locale === "sv") return sv_sales_status_loading(inputs)
	if (locale === "vi") return vi_sales_status_loading(inputs)
	if (locale === "tr") return tr_sales_status_loading(inputs)
	if (locale === "cs") return cs_sales_status_loading(inputs)
	if (locale === "bg") return bg_sales_status_loading(inputs)
	if (locale === "ru") return ru_sales_status_loading(inputs)
	if (locale === "uk") return uk_sales_status_loading(inputs)
	if (locale === "ar") return ar_sales_status_loading(inputs)
	if (locale === "hi") return hi_sales_status_loading(inputs)
	if (locale === "th") return th_sales_status_loading(inputs)
	if (locale === "ja") return ja_sales_status_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_status_loading(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_status_loading(inputs)
	return ko_sales_status_loading(inputs)
});
export { sales_status_loading as "sales.status.loading" }